import { render, staticRenderFns } from "./TokenManagementLiquidityPoolTable.vue?vue&type=template&id=4b3b1f02&lang=pug"
import script from "./TokenManagementLiquidityPoolTable.vue?vue&type=script&lang=ts"
export * from "./TokenManagementLiquidityPoolTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
